<h2 mat-dialog-title class="dialog-title">
  <mat-icon color="warn" class="icon-spacing">warning</mat-icon>
  Confirm Document Restoration
</h2>

<mat-dialog-content class="mat-typography dialog-content">
  <p class="warning-text">
    You are about to restore the document to a previous state.
    <br />
    <strong class="attention-point">
      This action will create a new version and overwrite your current working changes.
    </strong>
  </p>

  <mat-divider></mat-divider>

  <div class="version-details">
    <h3>Version Details:</h3>

    <div class="detail-row">
      <span class="label">ID:</span>
      <span class="value version-id">{{ data.version.version_id }}</span>
    </div>

    <div class="detail-row">
      <span class="label">Alias:</span>
      <span class="value alias">{{ data.version.alias || 'N/A' }}</span>
    </div>

    <div class="detail-row">
      <span class="label">Creation Date:</span>
      <time class="value date">{{ data.version.created_at | date: 'medium' }}</time>
    </div>

    @if (data.version.tags?.length) {
      <div class="detail-row tags-row">
        <span class="label">Tags:</span>
        <div class="value tags-container">
          <mat-chip-listbox>
            @for (tag of data.version.tags; track tag) {
              <mat-chip>{{ tag }}</mat-chip>
            }
          </mat-chip-listbox>
        </div>
      </div>
    }

    @if (data.version.restored_version_id) {
      <div class="restored-from">
        <mat-icon class="icon-spacing blue-icon">history</mat-icon>
        <span class="history-note">
          This version was itself a restoration of:
          <strong>{{ data.version.restored_version_alias || 'Unnamed Version' }}</strong>
          ({{ data.version.restored_version_id }})
        </span>
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-flat-button (click)="onCancel()" class="cancel-button">Cancel</button>
  <button mat-flat-button color="warn" (click)="save()" cdkFocusInitial class="confirm-button">
    <span class="restore-button-content">
      @if (isSaving) {
        <mat-progress-spinner [mode]="'indeterminate'" [diameter]="20"></mat-progress-spinner>
      } @else {
        <mat-icon>restore</mat-icon>
      }

      Restore Document</span
    >
  </button>
</mat-dialog-actions>
